import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RouteWiseCollectionTypeReport } from './Pages';

export const RouteWiseCollectionTypeReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={RouteWiseCollectionTypeReport} />
    </Fragment>
)